<template>
  <div>
    <div class="size-picker">
      <div class="mb-1 flex items-center" data-testid="show-sizes-overlay">
        <Headline class="mr-2" tag="span" look="h5" inline>
          {{ $t('pdp.size_heading') }}
        </Headline>
        <FimButton
          type="link"
          :no-padding="true"
          :aria-label="$t('store_finder.details_page.content.more_info')"
          @click="isSizeOverlayVisible = true"
        >
          <template #icon>
            <LazyIconFielmannInfoCircle class="size-5" />
          </template>
        </FimButton>
      </div>
      <div class="mb-3 items-baseline">
        <ProductDetailDescriptionText>
          <span>{{ $t('pdp.sizes_sunglasses_label') }}</span>
        </ProductDetailDescriptionText>
      </div>
      <Picker
        v-if="dropdownOptions.length > 1 && !hasDiopters"
        id="glasses-picker"
        v-model="packageUnitIndex"
        data-testid="pdp_button_size"
        class="mt-1 inline"
        :options="dropdownOptions"
        required
        @update:model-value="$emit('update:packageUnit', $event)"
      />
      <div v-else-if="dropdownOptions.length">
        <div class="mt-3 text-base">
          {{ dropdownOptions[0].label }}
        </div>
      </div>
    </div>

    <ClientOnly>
      <Overlay
        :title="$t('pdp.glasses.overlay.size_title')"
        :open="isSizeOverlayVisible"
        portal-target="#product-detail-size-portal"
        @update:open="isSizeOverlayVisible = $event"
      >
        <h2 class="mb-4 text-[24px] font-medium leading-[32px]">
          {{ $t('pdp.glasses.size_heading') }}
        </h2>
        <div
          v-dompurify-html="$t('pdp.glasses.overlay.size_text')"
          class="overlay space-y-4 text-lg leading-6"
        ></div>
      </Overlay>
    </ClientOnly>
  </div>
</template>

<script setup lang="ts">
const props = defineProps({
  packageUnit: { type: Number as PropType<number>, required: true },
  packageUnits: { type: Array as PropType<any[]>, required: true },
  hasDiopters: { type: Boolean as PropType<boolean>, default: false },
})

defineEmits(['update:packageUnit'])

const dropdownOptions = computed(() => {
  const sizeOrder = ['S', 'M', 'L']
  return props.packageUnits
    .map((unit) => ({
      ...unit,
      label: unit.shortLabel
        ? `${unit.shortLabel} – ${unit.label}`
        : unit.label,
    }))
    .sort((a, b) => {
      const aSize = a?.shortLabel?.toUpperCase() || ''
      const bSize = b?.shortLabel?.toUpperCase() || ''

      const aIndex = sizeOrder.indexOf(aSize)
      const bIndex = sizeOrder.indexOf(bSize)

      return aIndex - bIndex
    })
})

const isSizeOverlayVisible = ref(false)
const packageUnitIndex = toRef(props, 'packageUnit')
</script>
